import { render, staticRenderFns } from "./TranActivityParameterList.vue?vue&type=template&id=0bfa9747&scoped=true"
import script from "./TranActivityParameterList.vue?vue&type=script&lang=js"
export * from "./TranActivityParameterList.vue?vue&type=script&lang=js"
import style0 from "./TranActivityParameterList.vue?vue&type=style&index=0&id=0bfa9747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfa9747",
  null
  
)

export default component.exports